import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=a3bc8106&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=a3bc8106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bc8106",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3bc8106')) {
      api.createRecord('a3bc8106', component.options)
    } else {
      api.reload('a3bc8106', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=a3bc8106&scoped=true&", function () {
      api.rerender('a3bc8106', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gE1Q67ct3146/JS/comp/SearchFilterTokens.vue"
export default component.exports